import { render, staticRenderFns } from "./payment-list.vue?vue&type=template&id=6edffec4&scoped=true"
import script from "./payment-list.vue?vue&type=script&lang=js"
export * from "./payment-list.vue?vue&type=script&lang=js"
import style0 from "./payment-list.vue?vue&type=style&index=0&id=6edffec4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edffec4",
  null
  
)

export default component.exports